export default {
  "Satellite Imagery-Optical": "nhp_irr_satellite_imagery_optical",

  "Satellite Imagery-Microwave": "nhp_irr_satellite_imagery_microwave",
  "Crop Map": "nhp_irr_crop_map",
  "Crop Water Demand-Reference Evapotranspiration":
    "nhp_irr_crop_water_demand_reference_evapotranspiration",
  "Crop Water Demand-Crop Water Requirement":
    "nhp_irr_crop_water_demand_crop_water_requirement",
  "Crop Water Demand-Irrigation Water Requirement":
    "nhp_irr_crop_water_demand_irrigation_water_requirement",
};
